import * as React from "react"
import { Box, Divider, Grid, Typography, useTheme  } from "@mui/material"
import { CardSeeker, IconSeeker } from "@ui-seeker/core"
import { isEmpty, translateCountryName } from "@ui-seeker/utils"

import { LabelCountry } from "@components"
import { useSkuDetailsStockData } from "./@hooks"
import SkuDetailsStockCarousel from "./Carousel"
import SkuDetailsStockSkeleton from "./Skeleton"
import SkuDetailsStockWidget from "./Widget"


export default function SkuDetailsStockOverview() {

    const {  isLoadingStock, stockData, retailersFilterData, handleClickMarket, 
        sellersFilterData, handleClickMarketplace, selectedCountry, selectedMarketplace
    } = useSkuDetailsStockData()

    const { palette } = useTheme()

    const sxContainerSelectedValue = { sx: { 
		borderStyle: 'solid', 
		borderColor: palette.grey[600], 
		borderWidth: 4, 
		borderRadius: 2, 
		"&:hover": { cursor: 'pointer' } 
	} }

	const sxContainerValue = { sx: {
		"&:hover": { cursor: 'pointer' }
	} }

    if (isLoadingStock) return <SkuDetailsStockSkeleton />
	if (isEmpty(stockData)) return <></>

	return <CardSeeker title={'Stock & Assortment Overview'} sx={{ minHeight: '455px' }}>
        <Grid container spacing={3} id="widget">

            <Grid item xs={12}>
                <Box sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
                    Market:
                </Box>
                <Divider sx={{ mb: 2 }}/>
                <SkuDetailsStockCarousel>
                    { stockData.country.map(({ percentage, assortment, country }, idx) => <SkuDetailsStockWidget
                        key={idx}
                        percentage={percentage}
                        assortment={assortment}
                        sxContainer={selectedCountry === country ? sxContainerSelectedValue : sxContainerValue}
                        title={<LabelCountry country={country} label={translateCountryName(country)} sx={{ justifyContent: 'center' }} />}
                        onClick={() => handleClickMarket(country)}
                    /> )}
                </SkuDetailsStockCarousel>
            </Grid>

            {!!retailersFilterData?.length && <Grid item xs={12}>
                <Box sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
                    Retailers:
                </Box>
                <Divider sx={{ mb: 2 }}/>
                <SkuDetailsStockCarousel>
                    { retailersFilterData.map(({ percentage, assortment, country, retailer, siteID, isMarketplace }, idx) => {
                        const sxContainerCustom = selectedMarketplace === siteID 
                            ? sxContainerSelectedValue 
                            : { sx: { 
                                "&:hover": { 
                                    cursor: isMarketplace ? 'pointer' : 'default'
                                }
                            }}
                        
                        return <SkuDetailsStockWidget
                            key={idx}
                            percentage={percentage}
                            assortment={assortment}
                            sxContainer={sxContainerCustom}
                            title={
                                <LabelCountry 
                                    country={country} 
                                    label={<Box sx={{ display: 'flex', alignItems: 'baseline' }}>
                                        {retailer} 
                                        {isMarketplace && <IconSeeker icon="cart-circle-check" tooltip="Click card to see sellers info" sx={{ ml: 1 }} />} 
                                        </Box>
                                    } 
                                    sx={{ justifyContent: 'center' }} 
                                />
                            }
                            onClick={() => handleClickMarketplace(siteID, isMarketplace)}
                        />
                    } )}
                </SkuDetailsStockCarousel>
            </Grid>}

            {!!sellersFilterData?.length && <Grid item xs={12}>
                <Box sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
                    Sellers:
                </Box>
                <Divider sx={{ mb: 2 }}/>
                <SkuDetailsStockCarousel>
                    { sellersFilterData.map(({ percentage, assortment, seller }, idx) => <SkuDetailsStockWidget
                        key={idx}
                        percentage={percentage}
                        assortment={assortment}
                        title={<Typography sx={{ fontSize: '1.125rem', fontWeight: 'bold' }}>{seller}</Typography>}
                    /> )}
                </SkuDetailsStockCarousel>
            </Grid>}

        </Grid>
    </CardSeeker>
}